import { useTranslation } from 'react-i18next';
import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useStockPoDetailModel } from "../backlogModel";

export default () => {
  
const { t } = useTranslation();
const { } =
    useStockPoDetailModel();
  return (
    <>
      <PageHeader />
      <DataBox />
    </>
  );
};
